import { useState } from "react";
import { Badge, Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import print from "../../../Enums/Print";
import Pagination from "../Pagination/Pagination";
import { ExportExcel } from "../../../Enums/Export";
import ReportsService from "../../../../services/ReportsService";
import Select from "react-select";

const UserReports = () => {
	const [data, setData] = useState([]);
	const [status, setStatus] = useState("");
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const reportsService = new ReportsService();
	const search = useSelector((state) => state.auth.search);
	const options = [
		{ label: Translate[lang].verified, value: true },
		{ label: Translate[lang].not_verified, value: false },
	];

	const printPage = () => {
		let headRow = [
			Translate[lang].name,
			Translate[lang].email,
			Translate[lang].phone,
			Translate[lang].no_of_orders,
			Translate[lang].no_of_matches,
			Translate[lang].status,
		];
		let dataInfo = data?.map((res) => {
			let info = {
				name: res?.fullname,
				email: res.email,
				phone: res.phone,
				no_of_orders: "-",
				no_of_matches: "-",
				status: res?.isVerified,
			};
			return info;
		});
		print("Users", headRow, lang, dataInfo);
	};

	return (
		<>
			<div className="d-flex justify-content-between mb-4 align-items-center">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang].users}
				</span>
				<div className="d-flex gap-8">
					<Button
						variant="outline-primary"
						onClick={() => ExportExcel(data, "users-reports")}>
						<i className="las la-download fs-20" /> {Translate[lang].export}
					</Button>
					<Button variant="primary" onClick={() => printPage()}>
						<i className="las la-print fs-20" /> {Translate[lang].print}
					</Button>
				</div>
			</div>
			<div class="accordion " id="accordionExample">
				<div class="accordion-item border-shadow p-0">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button fw-bold"
							type="button"
							style={{
								fontSize: "18px",
								background: "none",
								boxShadow: "none",
								color: "#000",
							}}
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne">
							{Translate[lang].filter}
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample">
						<div class="accordion-body px-0">
							<div className="row w-100 m-auto">
								<div className="col-4">
									<label>{Translate[lang].status}</label>
									<Select
										options={options}
										value={status}
										onChange={(e) => setStatus(e)}
									/>
								</div>
								<div className={!!status ? "col-4" : "col-2"}>
									<div className="d-flex h-100 gap-8 align-items-end">
										<Button
											variant="outline-primary"
											className="w-100"
											onClick={() => setShouldUpdate((prev) => !prev)}>
											{Translate[lang].apply}
										</Button>
										{!!status && (
											<Button
												variant="outline-danger"
												className="w-100"
												onClick={() => {
													setStatus("");
													setShouldUpdate((prev) => !prev);
												}}>
												{Translate[lang].clear_filter}
											</Button>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-4">
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].name}</strong>
									</th>
									<th>
										<strong>{Translate[lang].email}</strong>
									</th>
									<th>
										<strong>{Translate[lang].phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang].no_of_orders}</strong>
									</th>
									<th>
										<strong>{Translate[lang].no_of_matches}</strong>
									</th>
									<th>
										<strong>{Translate[lang].status}</strong>
									</th>
								</tr>
							</thead>

							<tbody className="table-body">
								{data?.map((item, index) => {
									return (
										<tr key={index} className="text-center">
											<td className="text-wrap-mode">{item.fullname}</td>
											<td>{item.email}</td>
											<td>{item.phone}</td>
											<td>{"-"}</td>
											<td>{"-"}</td>
											<td>
												<Badge
													className="text-capitalize cursor-pointer"
													variant={`${
														item?.isVerified ? "success" : "danger"
													} light`}>
													{
														Translate[lang][
															item?.isVerified ? "active" : "deactive"
														]
													}
												</Badge>
											</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setData}
						service={reportsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						type="user"
						param={
							!!status
								? {
										isVerified: status?.value,
								  }
								: ""
						}
					/>
				</div>
			</div>
		</>
	);
};

export default UserReports;
